/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_Quantities_LabelInputs */



/**
* | output |
* | --- |
* | "Promos and quantities" |
*
* @param {Promo_Movement_Quantities_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_quantities_label = /** @type {((inputs?: Promo_Movement_Quantities_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Quantities_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Promos et quantités")
	if (locale === "es") return /** @type {LocalizedString} */ ("Promos y cantidades")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Promos e quantidades")
	if (locale === "it") return /** @type {LocalizedString} */ ("Promo e quantità")
	return /** @type {LocalizedString} */ ("Promos and quantities")
});